var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCom = function SvgCom(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21730_20441)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0013 18.3327C14.6037 18.3327 18.3346 14.6017 18.3346 9.99935C18.3346 5.39698 14.6037 1.66602 10.0013 1.66602C5.39893 1.66602 1.66797 5.39698 1.66797 9.99935C1.66797 14.6017 5.39893 18.3327 10.0013 18.3327Z",
    stroke: "#4F4E65",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.58249 3.33252L10.4158 2.08252C15.4159 1.74919 17.4991 6.1103 17.9157 8.33252L17.0824 8.75065L15.8373 7.50417C15.7697 7.60079 15.6274 7.90389 15.4157 8.75065C14.999 10.4173 14.1657 9.58398 14.1657 8.33398L12.0824 6.66586C11.249 6.52697 9.49902 6.16586 9.16569 5.83252C8.83236 5.49919 8.19347 6.24919 7.91569 6.66586L7.08249 6.24919C6.9436 6.1103 6.74915 5.66586 7.08249 4.99919C7.41582 4.33252 8.88804 3.6103 9.58249 3.33252Z",
    fill: "#4F4E65",
    stroke: "#4F4E65",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.08281 9.16732C7.08281 8.50065 7.63837 8.33398 7.91615 8.33398C10.0003 8.33398 11.2487 8.75065 11.2487 9.16732C11.2487 9.50065 12.082 10.4173 12.4987 10.834C12.9154 10.9729 13.7487 11.334 13.7487 11.6673C13.7487 12.0007 12.9154 12.3618 12.4987 12.5007C12.082 13.7507 11.082 16.1673 10.4154 15.834C9.7487 15.5007 9.30425 12.9173 9.16536 11.6673C8.83203 11.334 7.91589 11.5284 7.49948 11.6673C5.83281 10.0007 7.08281 10.0007 7.08281 9.16732Z",
    fill: "#4F4E65",
    stroke: "#4F4E65",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.58464 7.08268C5.71772 5.97157 4.50068 5.41602 3.55644 5.41602C1.66797 6.24935 1.66797 7.84657 1.66797 8.54102C1.98271 8.88824 2.54027 9.16602 2.91797 9.16602C3.29566 9.16602 3.55644 8.88824 3.55644 8.54102C3.55644 8.54102 3.45155 8.19379 4.58464 7.08268Z",
    fill: "#4F4E65",
    stroke: "#4F4E65",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.7513 11.2508C3.41797 10.5842 2.36241 10.9733 1.66797 11.2511C1.66797 12.918 3.33464 15.2788 4.16797 16.2508V15.834L4.58464 14.1673C5.58464 13.1673 5.41797 12.7784 5.0013 12.5007C4.72352 12.5007 4.08464 11.9175 3.7513 11.2508Z",
    fill: "#4F4E65",
    stroke: "#4F4E65",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21730_20441"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCom);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/com.4373d6f6b59b08fac83fffa86184851c.svg";